import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import EmojiPicker from "emoji-picker-react";
import AdminHeader from "./Header";

const MediaForm = () => {
  const [mediaType, setMediaType] = useState("none");
  const [headerTitle, setHeaderTitle] = useState("");
  const [headerImage, setHeaderImage] = useState(null);
  const [headerVideo, setHeaderVideo] = useState(null);
  const [headerDocument, setHeaderDocument] = useState(null);
  const [bodyText, setBodyText] = useState("");
  const [footText, setFootText] = useState("");

  const [buttons, setButtons] = useState([
    { actionType: "Visit Website", text: "Shop Now", urlType: "Static", url: "" },
  ]);

  const handleChange = (index, field, value) => {
    const newButtons = [...buttons];
    newButtons[index][field] = value;
    setButtons(newButtons);
  };

  const addButton = () => {
    if (buttons.length < 3) {
      setButtons([...buttons, { actionType: "Visit Website", text: "", urlType: "Static", url: "" }]);
    }
  };

  const removeButton = (index) => {
    const newButtons = buttons.filter((_, i) => i !== index);
    setButtons(newButtons);
  };

  const [showPicker, setShowPicker] = useState(false);

  const handleEmojiClick = (emojiObject) => {
    setBodyText((prev) => prev + emojiObject.emoji);
  };

  const addFormatting = (tag) => {
    const formattedText =
      tag === "bold"
        ? `**${bodyText}**`
        : tag === "italic"
        ? `*${bodyText}*`
        : bodyText;
    setBodyText(formattedText);
  };

  const handleMediaChange = (e) => {
    setMediaType(e.target.value);
    setHeaderImage(null);
    setHeaderVideo(null);
    setHeaderDocument(null);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setHeaderImage(URL.createObjectURL(file));
    }
  };

  const handleVideoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setHeaderVideo(URL.createObjectURL(file));
    }
  };

  const handleDocumentUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setHeaderDocument(file.name);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted with data:", {
      mediaType,
      headerTitle,
      headerImage,
      headerVideo,
      headerDocument,
      bodyText,
      footText
    });
  };

  return (
    <AdminHeader>
    <div className="fixed-top-bar">
    <div className="container mt-4 mb-5">
      <h1>Message Template</h1>
      <h2>Header</h2>
      <p>Add a title or select the media type you want to get approved for this template's header</p>

      <div className="mb-3">
        <label className="me-3">
          <input type="radio" name="mediaType" value="none" checked={mediaType === "none"} onChange={handleMediaChange} />
          None
        </label>
        <label className="me-3">
          <input type="radio" name="mediaType" value="text" checked={mediaType === "text"} onChange={handleMediaChange} />
          Text
        </label>
        <label className="me-3">
          <input type="radio" name="mediaType" value="image" checked={mediaType === "image"} onChange={handleMediaChange} />
          Image
        </label>
        <label className="me-3">
          <input type="radio" name="mediaType" value="video" checked={mediaType === "video"} onChange={handleMediaChange} />
          Video
        </label>
        <label>
          <input type="radio" name="mediaType" value="document" checked={mediaType === "document"} onChange={handleMediaChange} />
          Document
        </label>
      </div>

      {mediaType === "text" && (
        <div className="mb-3">
          <input type="text" className="form-control" placeholder="Enter header title" value={headerTitle} onChange={(e) => setHeaderTitle(e.target.value)} />
        </div>
      )}

      {mediaType === "image" && (
        <div className="mb-3">
          <input type="file" accept="image/*" className="form-control" onChange={handleImageUpload} />
          {headerImage && <img src={headerImage} alt="Header" className="img-fluid mt-2" />}
        </div>
      )}

      {mediaType === "video" && (
        <div className="mb-3">
          <input type="file" accept="video/*" className="form-control" onChange={handleVideoUpload} />
          {headerVideo && <video controls width="400px;" height="400px;" className="mt-2"><source src={headerVideo} type="video/mp4" />Your browser does not support the video tag.</video>}
        </div>
      )}

      {mediaType === "document" && (
        <div className="mb-3">
          <input type="file" accept=".pdf,.doc,.docx" className="form-control" onChange={handleDocumentUpload} />
          {headerDocument && <p className="mt-2"><strong>Selected Document:</strong> {headerDocument}</p>}
        </div>
      )}

<div className="body-message mt-4">
      <h2>Body</h2>
      <p>Type your message below:</p>
      <textarea
        className="form-control"
        rows="4"
        placeholder="Enter your message..."
        value={bodyText}
        onChange={(e) => setBodyText(e.target.value)}
      ></textarea>

      <div className="mt-2">
      <button 
        className="btn btn-light me-2" 
        onClick={() => setShowPicker(!showPicker)}
      >
        😀
      </button>
        <button className="btn btn-light me-2" onClick={() => addFormatting("bold")}>
          <b>B</b>
        </button>
        <button className="btn btn-light me-2" onClick={() => addFormatting("italic")}>
          <i>I</i>
        </button>
        </div>

      {showPicker && <EmojiPicker onEmojiClick={handleEmojiClick} />}
    </div>

      <div className="body-message mt-4">
        <h2>Footer</h2>
        <p>Add a short line of text to the bottom of your message template</p>
        <textarea
          className="form-control"
          rows="2"
          placeholder="Enter your message..."
          value={footText}
          onChange={(e) => {
      if (e.target.value.length <= 80) {
        setFootText(e.target.value);
      }
    }}
        ></textarea>
        <small className="text-muted text-end">{footText.length}/80</small>
      </div>

      <div className="body-message mt-4">
      <h5>Buttons (Optional)</h5>
      <p>Create buttons that let customers respond to your message or take action.</p>

      <select className="form-select mb-3">
        <option>Call To Action</option>
      </select>

      {buttons.map((btn, index) => (
        <div key={index} className="d-flex flex-wrap gap-2 p-2 border rounded mb-2">
          {/* Action Type Dropdown */}
          <label htmlFor="url" className="small">Type of action </label>
          <select
            className="form-select"
            value={btn.actionType}
            onChange={(e) => handleChange(index, "actionType", e.target.value)}
          >
            <option>Visit Website</option>
            <option>Call Now</option>
          </select>

          {/* Button Text Input */}
          <label htmlFor="url" className="small">Button Text</label>
          <input
            type="text"
            className="form-control"
            placeholder="Button Text"
            maxLength={25}
            value={btn.text}
            onChange={(e) => handleChange(index, "text", e.target.value)}
          />

          {/* URL Type Dropdown */}
          <label htmlFor="url" className="small">URL type</label>
          <select
            className="form-select"
            value={btn.urlType}
            onChange={(e) => handleChange(index, "urlType", e.target.value)}
          >
            <option>Static</option>
            <option>Dynamic</option>
          </select>

          {/* Website URL Input */}
          <label htmlFor="url" className="small">Website URL</label>
          <input
            type="url"
            className="form-control"
            placeholder="Website URL"
            value={btn.url}
            onChange={(e) => handleChange(index, "url", e.target.value)}
          />

          {/* Remove Button */}
          {index > 0 && (
            <button className="btn btn-danger" onClick={() => removeButton(index)}>X</button>
          )}
        </div>
      ))}

      {/* Add Another Button */}
      {buttons.length < 3 && (
        <button className="btn btn-primary mt-2" onClick={addButton}>
          + Add Another Button
        </button>
      )}
          </div>
      <button type="submit" className="btn btn-primary mt-3 mb-4" onClick={handleSubmit}>Submit</button>
    </div>
    </div>
    </AdminHeader>
  );
};

export default MediaForm;
